export const calculateAmount = (rate, value, nonAssessedValue) => {
    if (isNotAssessedValueTax(rate)) return getNonAssessedValueTaxRate(rate) * nonAssessedValue;
    return round(rate * (value/1000),2);
}

export const round = (number, decimals) => {
    return Number(Math.round(number+'e'+decimals)+'e-'+decimals);
}

export const isNotAssessedValueTax = (rate) => {
    return typeof(rate) == 'object';
}

export const getNonAssessedValueTaxAmountName = (rate) => {
    return Object.getOwnPropertyNames(rate)[0];
}

export const getNonAssessedValueTaxRate = (rate) => {
    return rate[getNonAssessedValueTaxAmountName(rate)];
}